import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'unh-simple-tabs',
  styleUrls: ['./simple-tabs.component.scss'],
  template: `
    <ng-content></ng-content>
  `
})
export class SimpleTabsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
